import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import apostropheLogo from '../assets/img/madebya-web-logo-320x320.png';

const homePageLinks = [
  {
    href: '#work',
    text: 'Work',
  },
  // {
  //   href: '#',
  //   text: 'Journal',
  // },
  {
    href: '#meet',
    text: 'Meet',
  },
  {
    href: '#contact',
    text: 'Contact',
  },
];

const links = [
  {
    href: '/#work',
    text: 'Work',
  },
  // {
  //   href: '#',
  //   text: 'Journal',
  // },
  {
    href: '/#meet',
    text: 'Meet',
  },
  {
    href: '/#contact',
    text: 'Contact',
  },
];

const NavItemStyles = css`
  letter-spacing: 4px;
`;

const NavItemAnchorLink = styled(AnchorLink)`
  ${NavItemStyles};
`;

const NavItemLink = styled(Link)`
  ${NavItemStyles};
`;

const NavItem = ({ href, text }) => {
  const linkClasses =
    'px-2 sm:px-4 py-2 lowercase no-underline text-lg xl:text-xl font-bold text-grey-darkest hover:underline';
  return (
    <li className="mx-1 py-6">
      {href.indexOf('#') === 0 ? (
        <NavItemAnchorLink className={linkClasses} href={href} offset="100">
          {text}
        </NavItemAnchorLink>
      ) : (
        <NavItemLink className={linkClasses} to={href} offset="100">{text}</NavItemLink>
      )}
    </li>
  );
};

const NavList = styled.ul`
  ${tw`list-reset flex flex-row items-center justify-end max-w-3xl mx-auto`};
  li:nth-child(1) {
    margin-right: ${props => (props.isFixed ? 'auto' : 'initial')};
    display: ${props => (props.isFixed ? 'block' : 'none')};
  }
`;

const NavContainer = styled.nav`
  ${tw`w-full absolute pin-l pin-r pin-t`};
  background-color: ${props =>
    props.isFixed ? 'rgba(255, 255, 255, 0.9)' : 'transparent'};
`;

export const NavBar = ({ isFixed, logoVisible, useHashLinks }) => {
  return (
    <NavContainer isFixed={isFixed}>
      <NavList isFixed={isFixed || logoVisible}>
        <li className="flex-0 py-2 px-4">
          <img src={apostropheLogo} aria-hidden={true} className="h-12" />
        </li>
        {(useHashLinks ? homePageLinks : links).map((link, i) => <NavItem key={i} {...link} />)}
      </NavList>
    </NavContainer>
  );
};

NavBar.propTypes = {
  logoVisible: PropTypes.bool.isRequired,
  isFixed: PropTypes.bool,
  useHashLinks: PropTypes.bool,
};

NavBar.defaultProps = {
  isFixed: false,
  useHashLinks: false,
};



// WEBPACK FOOTER //
// ./src/components/NavBar.js